import { useState, useEffect, useContext } from 'react';
import { CountryCode } from '@dayetopia/types';
import { Context } from '@components/Context';
import useCustomer from '@components/dashboard/utils/useCustomer';
import { getLocaleByCountryCode } from './language';

const useChosenCountry = () => {
  const [chosenCountryFromState, setChosenCountryFromState] = useState<CountryCode | null>(null);
  const { state, dispatch } = useContext(Context);
  const { chosenCountry } = state;
  const customer = useCustomer(state);

  useEffect(() => {
    if (chosenCountry) {
      setChosenCountryFromState(chosenCountry);
    }
  }, [chosenCountry]);

  const updateChosenCountry = (newCountry: CountryCode) => {
    setChosenCountryFromState(newCountry);
    dispatch({ type: 'setChosenCountry', data: newCountry });
    customer.update({ locale: getLocaleByCountryCode(newCountry) });
  };

  return { chosenCountry: chosenCountryFromState, updateChosenCountry };
};

export default useChosenCountry;
